import { classNames } from '@panwds/tailwindcss';
import React, { useState, useEffect } from 'react';

const TextInput = ({ dataMetrics, dataTestId, onValueSubmit, disabled, enableInitialFocus, placeholder, defaultValues, filterValue, noBorder }) => {
    const initialValue = filterValue || defaultValues || '';
    const [value, setValue] = useState(initialValue);
    useEffect(() => {
        setValue(initialValue);
    }, [filterValue]);
    const handleValueChange = (e) => {
        setValue(e.currentTarget.value);
    };
    const handleValueSelect = () => {
        onValueSubmit === null || onValueSubmit === void 0 ? void 0 : onValueSubmit(value);
    };
    const handleKeyPress = (e) => {
        if (value && e.key === 'Enter') {
            const current = document.activeElement;
            current.blur();
        }
    };
    return (React.createElement("div", { "data-metrics": dataMetrics, "data-testid": dataTestId || 'text-input', className: classNames('tw-m-0 tw-flex', noBorder ? '' : 'tw-box-border tw-border-solid tw-border-gray-300', 'tw-font-normal tw-text-gray-900', 'tw-leading-5 tw-w-full tw-items-center tw-h-8 tw-min-w-0 tw-pl-2 tw-pr-1 tw-pb-0 tw-pt-0', 'tw-border tw-rounded-r-full focus:tw-outline-none focus:tw-ring', 'tw-text-link') },
        React.createElement("input", { "data-testid": "text-input-filter", className: classNames('tw-border-none focus:tw-outline-none dark:tw-placeholder-gray-400 tw-text-gray-900 dark:tw-text-gray-400 tw-font-lato tw-bg-transparent', disabled && 'tw-text-disabled tw-cursor-not-allowed', 'tw-text-xs'), disabled: disabled, autoFocus: enableInitialFocus, placeholder: placeholder, value: value, onChange: handleValueChange, onKeyPress: handleKeyPress, onBlur: handleValueSelect })));
};

export { TextInput };
//# sourceMappingURL=TextInput.esm.js.map
